import { Block } from 'webiq.boilerplate'

export default class MobileFilterButton extends Block {
	static title = 'mobile-filter-button'

	init() {
		this.element.addEventListener('click', () => this.eventEmitter.emit('mobile-filter-button:toggle'))
	}
}
